export const months = [
  {
    value: "0",
    label: "January"
  },
  {
    value: "1",
    label: "February"
  },
  {
    value: "2",
    label: "March"
  },
  {
    value: "3",
    label: "April"
  },
  {
    value: "4",
    label: "May"
  },
  {
    value: "5",
    label: "June"
  },
  {
    value: "6",
    label: "July"
  },
  {
    value: "7",
    label: "August"
  },
  {
    value: "8",
    label: "September"
  },
  {
    value: "9",
    label: "October"
  },
  {
    value: "10",
    label: "November"
  },
  {
    value: "11",
    label: "December"
  }
];

export const years = [
  2024,
  2025,
  2026,
  2027,
  2028,
  2029,
  2030,
  2031,
  2032,
  2033,
  2034,
  2035,
  2036,
  2037,
  2038,
  2039,
  2040,
  2041,
  2042,
  2043,
  2044,
  2045,
  2046,
  2047,
  2048,
  2049,
  2050
];